/**
 * 账户实体
 */

import { useEffect, useState } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    AutoComplete,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '用户';

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [displayname, setDisplayname] = useState('');
    const [emailLists, setEmailLists] = useState([]);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [surname, setSurname] = useState('');
    const [name, setName] = useState('');


    const cancel = () => {
        props.setIsModalOpen(false);
        setLoading(false);
        setUsername('');
        setDisplayname('');
        setEmail('');
        setPhone('');
        setSurname('');
        setName('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setUsername(props.record.username);
            setDisplayname(props.record.displayname);
            setEmail(props.record.email);
            setPhone(props.record.phone);
            setSurname(props.record.surname);
            setName(props.record.name);
        }
    }, [props.record]);

    const searchEmail = (value) => {
        let rts;
        if (!value || value.indexOf('@') >= 0) {
            rts = [];
        } else {
            rts = [
                'qq.com',
                '163.com',
                'aliyun.com',
                'xinzhiteng.top',
            ].map(domain => `${value}@${domain}`);
        }
        setEmailLists(rts);
    }

    const ok = () => {
        //  参数校验
        if (!CNF.regex.username.exec(username)) {
            messageApi.error('用户名格式错误！', CNF.messageDuration);
            return;
        }
        if (displayname === '') {
            messageApi.error('显示名不能为空！', CNF.messageDuration);
            return;
        }
        if (!CNF.regex.email.exec(email)) {
            message.error('邮箱格式错误！', CNF.messageDuration);
            return;
        }
        if (!CNF.regex.phone.exec(phone)) {
            message.error('手机号格式错误！', CNF.messageDuration);
            return;
        }
        if (!CNF.regex.surname.exec(surname)) {
            message.error('姓格式错误！', CNF.messageDuration);
            return;
        }
        if (!CNF.regex.name.exec(name)) {
            message.error('名格式错误！', CNF.messageDuration);
            return;
        }
        setLoading(true);

        $.ajax({
            url: CNF.api + 'users' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'username': username,
                'displayname': displayname,
                'email': email,
                'surname': surname,
                'name': name,
                'phone': phone,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
                setLoading(false);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.isModalOpen}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>{rff}用户名</Col>
                    <Col span={11} offset={2}>{rff}邮箱</Col>
                    <Col span={11}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setUsername(e.target.value)}
                            value={username}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        {
                            [0].map((item) => {
                                const rts = emailLists;
                                const { Option } = AutoComplete;
                                const chr = rts.map(email => <Option key={email}>{email}</Option>);
                                return (
                                    <AutoComplete
                                        placeholder='请输入'
                                        key={item}
                                        style={{ width: '100%' }}
                                        value={email}
                                        onChange={(value) => setEmail(value)}
                                        onSearch={searchEmail}
                                        disabled={loading}
                                        defaultActiveFirstOption={true}
                                    >
                                        {chr}
                                    </AutoComplete>
                                );
                            })
                        }
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>{rff}显示名</Col>
                    <Col span={11} offset={2}>{rff}电话</Col>
                    <Col span={11}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setDisplayname(e.target.value)}
                            value={displayname}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setPhone(e.target.value)}
                            value={phone}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>{rff}姓</Col>
                    <Col span={11} offset={2}>{rff}名</Col>
                    <Col span={11}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setSurname(e.target.value)}
                            value={surname}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity